import React, { useEffect, useState } from "react";
// import "./UserManagement.scss";
import { loginScreen, userPlaceholderIcon } from "assets/images";
import { Link, useParams } from "react-router-dom";
import { toastMessage } from "utils/toastMessage";
import useFullPageLoader from "common/UseFullPageLoader";
import { CustomModal } from "components/modals/ModalBox";

import { IoMdArrowRoundBack } from "react-icons/io";
import { searchDateFormat, timeFormat } from "common/InputForm";
import { productDetailApi } from "services/product";
import { charLimit } from "utils/formValidator";

const ProductDetail = () => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const { id } = useParams();
  const [formData, setFormData] = useState({});
  const [imagePreview, setImagePreview] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [descriptionModal, setDescriptionModal] = useState(false);
  const [description, setDescription] = useState("");

  useEffect(() => {
    fetchPostDetails(id);
  }, [id]);
  const fetchPostDetails = async () => {
    try {
      const res = await productDetailApi(id);
      console.log(res.data.data.product, "detail");
      if (res?.status === 200) {
        setFormData({
          productId: id,
          brand: res.data.data.product.brand?.name,
          category: res.data.data.product.category,
          description: res.data.data.product.description,
          title: res.data.data.product.title,
          images: res.data.data.product.images,
          price: res.data.data.product.price,
          height: res.data.data.product.height,
          bodyShape: res.data.data.product.bodyShape,
          styleIdentity: res.data.data.product.styleIdentity,
          flauntParts: res.data.data.product.flauntParts,
          downplayParts: res.data.data.product.downplayParts,
          sizes: res.data.data.product.sizes,
          paletteName: res.data.data.product.paletteName,
          quantity: res.data.data.product.quantity,
          averageRating: res.data.data.product.averageRating,
          totalReviews: res.data.data.product.totalReviews,
          addedBy: res.data.data.product.addedBy,
          createdAt: res.data.data.product.createdAt,
          productCode: res.data.data.product.productCode
        });
      } else {
        toastMessage(res?.data?.message, "error", "event Detail");
      }
    } catch (e) {
      toastMessage(e.message, "error", "event Detail");
    }
  };

  return (
    <>
      {loader}
      <div className="editProfile user_management product_details">
        <div className="dashboard_title">
          <h3>
            <Link to={"/product-management/exclusive"}>
              <IoMdArrowRoundBack />
            </Link>{" "}
            Product details
          </h3>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="personal_details _box spacing">
              <div className="details_list ">
                <ul className="listing_detail">
                  <li>
                    <b>Title</b>
                    <span>{formData?.title}</span>
                  </li>
                  <li>
                    <b>Description</b>
                    <span className="nowrap">
                      {formData?.description?.length > 50 ? (
                        <div className="d-flex wrap_td_span">
                          <p
                            dangerouslySetInnerHTML={{
                              __html: charLimit(formData?.description, 30),
                            }}
                          ></p>
                          &nbsp;
                          <button
                            className="readMore"
                            onClick={() => {
                              setDescriptionModal(true);
                              setDescription(
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: formData?.description,
                                  }}
                                ></p>
                              );
                            }}
                          >
                            <b>Read More</b>
                          </button>
                        </div>
                      ) : (
                        <div className="d-flex wrap_td_span">
                          <p
                            dangerouslySetInnerHTML={{
                              __html: formData?.description,
                            }}
                          ></p>
                        </div>
                      )}
                    </span>
                  </li>
                  <li>
                    <b>Product Code</b>
                    <span>{formData?.productCode || "N/A"}</span>
                  </li>
                  <li>
                    <b>Created At</b>
                    <span>{searchDateFormat(formData?.createdAt)}</span>
                  </li>
                  <li>
                    <b>Palette Name</b>
                    <span>
                      {formData?.paletteName?.length
                        ? formData?.paletteName.join(",")
                        : "---"}
                    </span>
                  </li>
                  <li>
                    <b>Brand</b>
                    <span>{formData?.brand}</span>
                  </li>
                  <li>
                    <b>Category</b>
                    <span>{formData?.category}</span>
                  </li>
                  <li>
                    <b>Body Shape</b>
                    <span>
                      {formData?.bodyShape?.length
                        ? formData?.bodyShape.join(",")
                        : "---"}
                    </span>
                  </li>
                  <li>
                    <b>Style Identity</b>
                    <span>{formData?.styleIdentity?.length
                      ? formData?.styleIdentity.join(",")
                      : "---"}</span>
                  </li>
                  <li>
                    <b>Downplay Parts</b>
                    <span> {formData?.downplayParts?.length
                      ? formData?.downplayParts.join(",")
                      : "---"}</span>
                  </li>
                  <li>
                    <b>Flaunt Parts</b>
                    <span> {formData?.flauntParts?.length
                      ? formData?.flauntParts.join(",")
                      : "---"}</span>
                  </li>

                  <li>
                    <b>Style Identity</b>
                    <span>{formData?.styleIdentity}</span>
                  </li>
                  <li>
                    <b>Sizes</b>
                    <span>{formData?.sizes}</span>
                  </li>
                  <li>
                    <b>Height</b>
                    <span>{formData?.height}</span>
                  </li>
                  <li>
                    <b>Quantity</b>
                    <span>{formData?.quantity}</span>
                  </li>
                  <li>
                    <b>Price</b>
                    <span>₹{formData?.price}</span>
                  </li>
                  <li>
                    <b>Average Rating</b>
                    <span>{formData?.averageRating}</span>
                  </li>
                  <li>
                    <b>Average Reviews</b>
                    <span>{formData?.totalReviews}</span>
                  </li>
                
                </ul>
              </div>
            </div>
            <div className="tab_content">
              <div className="post_details">
                {/* Render  data */}
                <div className="post_item">
                  <div className="image_gallery">
                    <h5>Images</h5>
                    <ul className="image_list">
                      {formData.images?.map((image) => {
                        return (
                          <>
                            <li
                              onClick={() => {
                                setImagePreview(true);
                                setImageUrl(image?.url);
                              }}
                            >
                              <img
                                src={image?.url}
                                // alt={`image`}
                                className="post_image"
                              />
                            </li>
                          </>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        show={imagePreview}
        handleClose={() => setImagePreview(false)}
        className={"image_preview_modal "}
      >
        <img src={imageUrl ? imageUrl : loginScreen} alt="" />
      </CustomModal>
      {descriptionModal && (
        <CustomModal
          className={"add_model"}
          show={descriptionModal}
          handleClose={() => {
            setDescriptionModal(false);
          }}
        >
          <h3>Description</h3>
          <h7>{description}</h7>
        </CustomModal>
      )}
    </>
  );
};

export default ProductDetail;
